// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@guestsupply/XDL/Utilities";
import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import Users from "@insite/mobius/Icons/Users";
import { css } from "styled-components";

wishListSharingStatusStyles.statusText = {
    css: css`
        display: flex;
        align-items: center;
        > span {
            display: flex;
            align-items: center;
        }
    `,
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    size: 15,
    css: css`
        margin-right: 5px;
        svg {
            color: ${color("common.ui8")};
        }
        &:hover {
            svg {
                color: ${color("text.link")};
            }
        }
    `,
};
